import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Button, Tabs, Tab } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import ReactDOM from 'react-dom';

import { DateFormatter2 } from '../../Common/dateFormat';

const ESCAPE_KEY = 27;
const ENTER_KEY = 13;

const { Selectors } = Data;

export class BatchModal extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      quantityRemaining: 0,
      
      changed: false,
      oldLoaded: 0,
    }
  }

  // returnTotalWeight={ this.returnTotalWeight.bind(this) }
  // keepLoaded={this.keepLoaded}
  // oldLoaded={this.state.oldQuantity}
  componentDidMount() {
    if (this.props.batchesInfo && this.props.batchesInfo.batches.length) {
      // here somwtime ProductNum is undefined
      // const {
      //   batches,
      // } = this.props.generateBatchRelatedInfo(this.props.selectedInventoryRow.ProductNum)
      const {
        batches,
      } = this.props.generateBatchRelatedInfo(this.props.rowProduct)
      this.initializeModal(batches);
    }
    // document.addEventListener("keydown", this._handleKeyDown);
    
    // from weight
    if (this.props.invoice) {
    //   let rows = [];
    console.log('currentBetches: ', this.props.currentBetches)
    //   this.props.currentWeights.map((weight) => {
    //     rows.push({ Weight: weight });
    //   });
    // 
    //   const oldLoaded = rows.length;
    //   if (rows.length < this.props.totalLoaded) {
    //     const temp = rows.length;
    //     for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
    //       rows.push({ Weight: 0 });
    //     }
    //   }
    // 
    //   if ((parseFloat(this.props.totalLoaded) < rows.length)) {
    //     let replace = [];
    //     for(let i= 0; i< parseFloat(this.props.totalLoaded); i++) {
    //       replace.push(rows[i]);
    //     }
    //     rows = [...replace];
    //   }
    //   const weights = { ...this.state.weights, rows };
    //   this.handleSetTotalWt(weights);
    //   this.setState({ weights });
    // } else {
    //   this.props.fetchSalesOrderLineWeights(this.props.rowChosen);
    }
    // ReactDOM.findDOMNode(this.refs['TotalWeight'].getRenderedComponent().myInput.refs.input).focus();
    // ReactDOM.findDOMNode(this.refs['Ref'].getRenderedComponent()).focus();
    // ReactDOM.findDOMNode(this.refs['Ref']).focus();
  }
  
  componentWillUnmount() {
    // document.removeEventListener("keydown", this._handleKeyDown);
    if (!this.state.changed) {
      this.props.keepLoaded(this.props.oldLoaded || this.state.oldLoaded);
    }
  }

  _handleKeyDown = (event) => {
    switch (event.keyCode) {
      case ENTER_KEY:
        this.handleOnSubmit();
        break;
      default:
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
  }

  initializeModal = (array) => {
    const { selectedInventoryRow } = this.props;
    const IsOverSaleable = selectedInventoryRow ? selectedInventoryRow.IsOverSaleable : false;

    let index = 0;
    let formatter = [];
    let quantityRemaining = this.props.quantityValue;
    if (array && array.length > 0) {
      array.map(r => {
        let qty = 0;
        if (r.quantity >= quantityRemaining) {
          qty = quantityRemaining;
          quantityRemaining = 0;
        } else {
          if (r.quantity >= 0) {
            qty = r.quantity;
            quantityRemaining -= r.quantity;
          }
        }
        formatter.push({ Idx: index++, batchId: r.id, quantity: qty,
          expire_datetime: r.expire_datetime, location: r.location, 
          batch_num: r.batch_num, availableQty: r.quantity,
          is_initial_batch: r.is_initial_batch, case_per_layer: r.case_per_layer,
          layer_per_pallet: r.layer_per_pallet, avg_wt: r.avg_wt, package_date: r.package_date
        });
      })
    } else {
      formatter = [];
      // formatter.push({ Idx: 0, batchId: null, quantity: "0", expire_datetime: null, location: null, batch_num: null, availableQty: null });
    }
    // for HMM doesnt matters or isOverSaleable
    if ((quantityRemaining && IsOverSaleable)) {
      const initialBatchIndex = _.findIndex(formatter, batch => batch.is_initial_batch);
      formatter[initialBatchIndex].quantity += parseInt(quantityRemaining);
      quantityRemaining = 0;
    }
    this.setState({
      rows: formatter,
      selectedRows: [],
      editedRows: [],
      quantityRemaining,
    });
  }

  handleOnSubmit = (e) => {
    const { rows } = this.state;
    let totalWeight = 0;
    const batchRows = [];
    rows.map((row) => {
      if (row.quantity>0) {
        if (row.avg_wt) {
          totalWeight += parseFloat(row.avg_wt)* row.quantity;
        }
        batchRows.push({
          Batch_id: row.batchId,
          BatchExpiredDate: row.expire_datetime,
          BatchLocation: row.location,
          BatchQty: row.quantity,
          BatchAveWt: row.avg_wt,
        });
      }
    });
    
    this.props.returnBatch(totalWeight.toFixed(2), batchRows);
    this.setState({ changed: true }, () => { this.props.closeC(); });
  };

  // this only works on the left table
  onClickAddAll(idx) {
    const { selectedInventoryRow, selectedproductRow } = this.props;
    console.log('selectedInventoryRow: ', selectedInventoryRow)
    console.log('selectedproductRow: ', selectedproductRow)
    
    const { IsOverSaleable } = selectedInventoryRow;
    let { rows, quantityRemaining } = this.state;
    rows.map((r, index) => {
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        if (r.availableQty >= quantityRemaining || (IsOverSaleable && r.is_initial_batch)) {
          rows[index].quantity = quantityRemaining;
          quantityRemaining = 0;
        } else {
          rows[index].quantity = r.availableQty;
          quantityRemaining = Number(quantityRemaining) - Number(r.availableQty);
        }
      }
    });
    this.setState({ rows, quantityRemaining });
  }

  onClickRemoveAll(idx) {
    let { rows, quantityRemaining } = this.state;
    rows.map((r, index) => {
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        rows[index].quantity = 0;
      }
    });
    this.setState({ rows, quantityRemaining });
  }

  renderAgentTable() {
    const getRows = () => {
      return Selectors.getRows(this.state);
    }
    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }

    const handleRowUpdated = e => {
      const {
        IsOverSaleable,
      } = this.props.selectedInventoryRow;
      
      this.setState({ sortColumn: null, sortDirection: null })
      let { quantityRemaining } = this.state;
      let rows = getRows();
      let editedRows = this.state.editedRows.slice(0);
      const line = rows[e.rowIdx];
      const canExceed = IsOverSaleable && line.is_initial_batch;
      if (e.updated && e.updated.quantity > line.availableQty && !canExceed) {
        alert("Cannot exceed available quantity.");
        return;
      } else if (e.updated && e.updated.quantity > quantityRemaining) {
        alert("Cannot exceed remaining quantity.");
        return;
      } else if ((Number(e.updated.quantity) !== Number(rows[e.rowIdx].quantity))) {
        this.setState({ quantityRemaining: Number(this.state.quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
      }

      Object.assign(rows[e.rowIdx], e.updated);
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx)
          editedRows.splice(index, 1)
      }, this);
      editedRows.push(rows[e.rowIdx]);
      this.setState({
        rows: rows,
        editedRows: editedRows,
      });
    }
    const onRowsSelected = (rows) => {
      let newRows = getRows();
      let selectedRows = [...this.state.selectedRows];
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      this.setState({ rows: newRows, selectedRows });
    }
    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      let selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    }

    const columns = [
      {
        key: 'Idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 100,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: '100%' }}
          >
            <span onClick={() => {
              this.onClickAddAll(value);
            }}
              style={{ cursor: "pointer", color: "green", marginRight: '12px' }}
            >+All</span>
            <span onClick={() => {
              this.onClickRemoveAll(value);
            }}
              style={{ cursor: "pointer", color: "red" }}
            >-All</span>
          </div>
        ),
        width: 100,
        getRowMetaData: (row) => row,
      },
      {
        key: 'quantity',
        name: <Translate value="quantity" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 90,
      },
      {
        key: 'availableQty',
        name: <Translate value="available" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'expire_datetime',
        name: <Translate value="expired" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
        formatter: DateFormatter2,
      },
      {
        key: 'location',
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: 'batch_num',
        name: <Translate value="batch_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: 'package_date',
        name: <Translate value="pack_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
        formatter: DateFormatter2,
      },
      {
        key: 'avg_wt',
        name: <Translate value="avg_wt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
    ]

    return (
      <Row>
        <label style={{ color: 'orange', fontSize: '15px' }}><Translate value="quantity_remaining" />: {this.state.quantityRemaining}</label>
        <Col>
          <div style={{ maxWidth: '850px', marginLeft: '25px' }}>
            <ReactDataGrid
              // rowKey="Idx"
              enableCellSelect={true}
              rowRenderer={
                <RowRenderer />
              }
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={300}
              rowHeight={25}
              headerRowHeight={45}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    )
  }

  render() {
    const {
    } = this.state;
    return (
      <div>
        <Row ref='Ref'>
          <Col className="text-center">
            <span>
              {this.renderAgentTable()}
            </span>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: '20px' }}>
          <Button
            style={{ marginRight: '5px' }}
            bsStyle="success"
            onClick={(e) => { this.handleOnSubmit(e); }}
          >
            <Translate value="add_batches" />
          </Button>
        </Row>
      </div>
    );
  }
}

class RowRenderer extends Component {
  render() {
    return (
      <div style={{color:'black'}}>
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

export default BatchModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/BatchModal.jsx